import React from 'react';
import Icon from '@mdi/react';
import { mdiAccountCheck } from '@mdi/js';
import theme from '../theme'; 

export const CheckInIcon = size => (
  <Icon 
    size={size}
    path={mdiAccountCheck}
    title="Check In"
    color={theme.white}
  />
);